import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    listContainer: {
      height: "100%",
      position: "relative"
    },
    productList: {
      "& div:first-child": {
        fontSize: "large"
      }
    },
    ranking: {
      fontWeight: "bold"
    },
    productName: {
      paddingLeft: "0.5rem",
      paddingRight: "0.5rem",
      wordBreak: "break-word"
    },
    priceQty: {
      marginRight: 0,
      marginLeft: "auto"
    }
  })
);
